import api from '@/services/Api';

export default {
  get(brandId, dateRange) {
    const params = new URLSearchParams();

    if (brandId) {
      params.append('brand_id', brandId);
    }
    if (dateRange && dateRange.start && dateRange.end) {
      params.append('date_range[start]', formatDate(dateRange.start));
      params.append('date_range[end]', formatDate(dateRange.end));
    }

    return api().get(`/dashboard?${params.toString()}`);
  },

  getActivityLogs(brandId, dateRange, page = 0, limit = 20) {
    const params = new URLSearchParams();

    if (brandId) {
      params.append('brand_id', brandId);
    }

    if (dateRange && dateRange.start && dateRange.end) {
      const startDate = dateRange.start.toISOString().split('T')[0];
      const endDate = dateRange.end.toISOString().split('T')[0];

      params.append('date_range[start]', startDate);
      params.append('date_range[end]', endDate);
    }

    params.append('page', page);
    params.append('limit', limit);

    return api().get(`/dashboard/activity-logs?${params.toString()}`);
  },

  updateSettings(settings) {
    return api().put('/dashboard/settings', settings);
  },
};

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
